import API from "../config/api.js";

export const StockReportService = {
  getStockReport(filters = {}, search = "", page = 1) {
    return API.get("/api/stocks/report", {
      params: { ...filters, search, page },
    });
  },
  getBranches() {
    return API.get("/api/stocks/branches");
  },
  getStores() {
    return API.get("/api/stocks/stores");
  },
  getProducts() {
    return API.get("/api/stocks/products");
  },
  getBatches() {
    return API.get("/api/stocks/batches");
  },
};
